import { createAction, props } from '@ngrx/store';

import { DashboardListEntity } from '../components/dashboard-list/dashboard-list.entity';

export enum DashboardActions {
	InitDashboardList = '[Dashboard] get dashboard list',
	RefreshDashboardList = '[BE][Dashboard] refresh dashboard list',
	FetchDashboardListFail = '[BE][Dashboard] fetch dashboard list fail',
	FetchDashboardListSuccess = '[BE][Dashboard] fetch dashboard list success',
	NavigateToDashboardRoute = '[Dashboard] navigate to dashboard route',
	NavigateToDashboardCreateRoute = '[Dashboard] navigate to dashboard create route',
	OpenDeleteConfirmationPopup = '[Dashboard] open delete confirm popup',
	DeleteDashboard = '[Dashboard] delete dashboard',
	BulkDeleteDashboards = '[Dashboards] delete many dashboards',
	DeleteDashboardSuccess = '[BE][Dashboard] delete dashboard success',
	DeleteDashboardFail = '[BE][Dashboard] delete dashboard fail',
	ToggleDashboardStatus = '[Dashboard] toggle dashboard status',
	NavigateToDashboardsCarouselRoute = '[Dashboard] navigate to dashboards carousel route',
}

export const initDashboardList = createAction(
	DashboardActions.InitDashboardList
);

export const refreshDashboardList = createAction(
	DashboardActions.RefreshDashboardList
);

export const fetchDashboardListSuccess = createAction(
	DashboardActions.FetchDashboardListSuccess,
	props<{ dashboardList: DashboardListEntity }>()
);

export const fetchDashboardListFail = createAction(
	DashboardActions.FetchDashboardListFail,
	props<{ error: unknown }>()
);

export const navigateToDashboard = createAction(
	DashboardActions.NavigateToDashboardRoute,
	props<{
		id: number;
		goToVisuTab: boolean;
	}>()
);

export const navigateToDashboardCreate = createAction(
	DashboardActions.NavigateToDashboardCreateRoute
);

export const navigateToDashboardsCarouselRoute = createAction(
	DashboardActions.NavigateToDashboardsCarouselRoute
);

export const openDeleteConfirmationPopup = createAction(
	DashboardActions.OpenDeleteConfirmationPopup,
	props<{ dashboardId: Array<number>; dashboardLabel: string }>()
);

export const deleteDashboard = createAction(
	DashboardActions.DeleteDashboard,
	props<{ dashboardId: number }>()
);

export const bulkDeleteDashboards = createAction(
	DashboardActions.BulkDeleteDashboards,
	props<{ dashboardIds: Array<number> }>()
);

export const deleteDashboardSuccess = createAction(
	DashboardActions.DeleteDashboardSuccess
);

export const deleteDashboardFail = createAction(
	DashboardActions.DeleteDashboardFail,
	props<{ error: unknown }>()
);

export const toggleDashboardStatus = createAction(
	DashboardActions.ToggleDashboardStatus,
	props<{ dashboardId: number; status: boolean }>()
);
